export default "__VITE_ASSET__N8xzn8AC__"